import { Link } from "react-router";
import Image from "../other/Image/Image";
import { dialogNotify } from "../../services/Notifications/NotificationServices";
import { useState } from "react";
import {
  redirectToLogin,
  redirectToRegistration,
} from "../../../pages/Login/services/authService";
import { isDebugMode } from "../../utils/isDebugMode";

interface NavBarMenuProps {
  isLogged: boolean;
  avatar: string;
  login: string | null;
  exit: () => void;
}

const NavBarMenu = ({ isLogged, avatar, login, exit }: NavBarMenuProps) => {
  const [isOpenProfileOptions, setIsOpenProfileOptions] = useState(false);

  const debugMode = isDebugMode();

  const authorization = (
    <>
      <p onClick={redirectToLogin} className="navbar-ref">
        Войти
      </p>
      <p onClick={redirectToRegistration} className="navbar-ref">
        Регистрация
      </p>
    </>
  );

  const profile =
    <div
      className="navbarMenu_profile"
      onClick={() => {
        if (isOpenProfileOptions) setIsOpenProfileOptions(false)
        else setIsOpenProfileOptions(true)
      }}
    >
      <Image
        className='navbarMenu_profile-avatar'
        resolution="avatar"
        src={avatar ? avatar : "../EmptyProfileSection/ava_empty162x162.png"}
        alt=""
        sizes="22px"
      />
      <p className="navbarMenu_profile-login">{login}</p>
      <img
        className={`navbarMenu_profile-arrow ${isOpenProfileOptions && 'open'}`}
        src='/arrow.svg' />
    </div>

  const profileOptions = (
    <>
      <Link className="navbar-ref" to={`/Cabinet/${login}`}>
        Профиль
      </Link>
      {debugMode &&
        <Link className="navbar-ref" to={`/Cabinet/${login}?notifications=true`}>
          Уведомления
        </Link>}
      <Link className="navbar-ref" to={`/Cabinet/${login}?profileEdit=true`}>
        Настройки
      </Link>
      <Link className="navbar-ref" to={`/my-purchases`}>
        Мои подписки
      </Link>
      <Link className="navbar-ref" to={`/teams?my=true`}>
        Мои команды
      </Link>
      <Link className="navbar-ref" to={`/organizers?my=true`}>
        Мои орггруппы
      </Link>
      <Link className="navbar-ref" to={`/Cabinet/${login}?armories=true`}>
        Мои привода
      </Link>
      <hr />
      <div
        className="navbar-ref"
        onClick={() =>
          dialogNotify({
            title: "Выход",
            status: "info",
            description: "Вы действительно хотите выйти ?",
            acceptHandler: exit,
            acceptText: "Да",
          })
        }
      >
        Выйти
      </div>
    </>
  );

  const content = isLogged ? profile : authorization;

  return (
    <div className="bordered navbarMenu">
      <Link className="navbar-ref" to="/promo">
        Главная
      </Link>
      <Link className="navbar-ref" to="/devicesoverview">
        Продукты
      </Link>
      <Link className="navbar-ref" to="/calendar">
        Игры
      </Link>
      <Link className="navbar-ref" to="/teams">
        Команды
      </Link>
      <Link className="navbar-ref" to="/organizers">
        Организаторы
      </Link>
      <hr />
      {content}
      {isOpenProfileOptions && profileOptions}
    </div>
  );
};

export default NavBarMenu;
